import React from 'react'
import HoursTable from './hours-table'
import OpenTable from './forms/open-table'
import LightboxGallery from './lightbox-gallery'
import { kebabCase } from 'lodash'
// import StyledImage from './styled-image'

export default function Gallery({ props, index }) {
    const { heading, description, images, hours, openTable, aspectRatio } = props
    const multipleHours = hours?.length + (openTable ? 1 : 0) > 2 || !hours
    const settingsOverrides = images ? {
        slidesToShow: multipleHours ? 4 : 3,
        slidesToScroll: 1,
        className: `slick-arrows-centered`,
        // className: `slick-arrows-centered has-thumbnails`,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
        // customPaging: function (i) {
        //     return (
        //         <button className="inline-block m-2">
        //             <StyledImage
        //                 image={images[i === images.length - 1 ? 0 : i + 1]}
        //                 objectFit="cover"
        //                 className="w-16 h-16 inline-block"
        //                 objectPosition={"center"} />
        //         </button>
        //     );
        // },
        // dots: true,
        // dotsClass: "slick-dots slick-thumb justify-center flex-wrap mt-8",
    } : null
    return (
        <section className={`my-12`}>
            <div className={`container relative pb-12  grid items-start ${!hours ? "" : multipleHours ? "" : "lg:grid-cols-3"} gap-12 lg:border-b border-b-slate/25`}>
                {(heading || description || images) ? <div className={`${!hours ? "" : multipleHours ? "" : "lg:col-span-2 lg:sticky lg:top-24 max-w-4xl"}`}>
                    {heading ?
                        <h2 id={kebabCase(heading)} className={`mb-2  `}>{heading}</h2>
                        : null}
                    {description && (
                        <div
                            className={`parsed-content mb-2`}
                            dangerouslySetInnerHTML={{
                                __html: description,
                            }}
                        />
                    )}
                    {images ?
                        <>
                            {images?.length > 2 ?
                                <div className={`pt-5 max-w-[calc(100vw_-_4rem)] ${multipleHours ? "sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-[88rem]" : "sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-3xl 2xl:max-w-4xl"}`}>
                                    <LightboxGallery props={{ images }} isCarousel={true} settingsOverrides={settingsOverrides} aspectRatio={aspectRatio} />
                                </div>
                                : <div className={`-mx-4 gap-y-4 lg:gap-y-8 mt-5 grid grid-cols-2 ${multipleHours ? "" : "md:grid-cols-3"}`}>
                                    <LightboxGallery props={{ images }} aspectRatio={aspectRatio} />
                                </div>}
                        </>
                        : null}
                </div> : null}
                {(hours || openTable) ?
                    <div className={`${multipleHours ? " 2xl:col-span-2" : ""}`}>
                        <ul className={`grid ${multipleHours ? "gap-y-6 gap-x-8 md:grid-cols-2" : "gap-4"}`}>
                            {hours?.map((hoursGroup, index) => {
                                return (
                                    <li key={index} className={`shadow-spread relative bg-white ${multipleHours ? "p-5" : "px-4 py-3"}`}>
                                        <HoursTable props={hoursGroup} multipleHours={multipleHours} />
                                    </li>
                                )
                            }
                            )}
                            {openTable ?
                                <li className={`shadow-spread-down relative bg-white ${multipleHours ? "p-5" : "px-4 py-3"}`}>
                                    <OpenTable openTable={openTable} />
                                </li>
                                : null}
                        </ul>
                    </div>
                    : null}


            </div>
        </section>
    )
}